import { Box } from '@mui/material';
import { TournamentEntity } from 'app/interfaces/entity';
import { MyTeamManageView } from 'modules/tournaments/components/BracketTournament/MyTeam/MyTeamManageView';
import { MyTeamPlayerView } from 'modules/tournaments/components/BracketTournament/MyTeam/MyTeamPlayerView';
import { MyTeamPlatformLinkingWarning } from 'modules/tournaments/components/BracketTournament/MyTeamPlatformLinkingWarning';
import { FINISHED_TOURNAMENT_STATUSES } from 'modules/tournaments/constants';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { usePlatformLinkAction } from 'shared/hooks';

export const MyTeam: FC = () => {
  const tournament: TournamentEntity = useSelector(currentTournamentSelector.tournament);
  const isCurrentUserCaptain = useSelector(currentTournamentSelector.isCurrentUserCaptain);
  const showTeamManagePage =
    isCurrentUserCaptain && !FINISHED_TOURNAMENT_STATUSES.includes(tournament?.status);

  const { isPlatformLinked } = usePlatformLinkAction(tournament?.game?.platformType);

  if (!isPlatformLinked) {
    return <MyTeamPlatformLinkingWarning />;
  }

  return (
    <Box p={3} bgcolor="background.paper">
      {showTeamManagePage ? (
        <MyTeamManageView tournament={tournament} />
      ) : (
        <MyTeamPlayerView tournament={tournament} />
      )}
    </Box>
  );
};
